/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Guardians} from '../../core/_models'

type Props = {
  guardians: Guardians
}

const InfoCell: FC<Props> = ({guardians}) => {

  const openEditModal = () => {
    window.open(guardians.video_name);
  }

  return (
    <div className='d-flex align-items-center'>
      {/* begin:: Avatar */}
      <div className='d-flex flex-column'>
        <a
          onClick={openEditModal}
          role='button'
          className='text-gray-800 text-hover-primary mb-1 pointer-cli'
        >
          {guardians.video_name}
        </a>
      </div>
    </div>
  )
}

export {InfoCell}
